import configBuilder from "@client/utils/configBuilder";

export const layers = {
  production: {
    aOrAn: "a",
    x_cc_app: "q3vsT1zXO",
    baseURL: "https://production-api.cardcash.com/",
    anycardURL: "https://checkout.cardcash.com/checkout.js",
    baseServerURL: "http://api.production/",
    bulkSalesEmail: "bulksales@cardcash.com",
    supportEmail: "support@cardcash.com",
    supportPhone: "1-800-227-4214",
    devMode: "production",
    ga: "",
    imgPrefix: "https://cdn.cardcash.com/website/",
    siftScienceBeacon: "20a58582f6",
    resellerRatingsId: 39711,
    siteHref: "https://cardcash.com",
    siteEnv: "https://cardcash.com",
    zipMerchantId: "d05de8be-d5c9-460f-a25c-ebac7428111d",
    zipTestEnv: false,
    zipJsURL: "https://cdn.us.zip.co/v1/zip.js",
    zipMinOrderAmount: 35,
    zipMaxOrderAmount: 1500,
    bulkContactFormURL:
      "https://9orqbsswk5.execute-api.us-east-1.amazonaws.com/production/bulk-buy-gift-cards",
    aiAssistURL: "https://ai-api.cardcash.com/v1/contact-form/assist",
    recaptchaV3SiteKey: "6LflGwUuAAAAAPwt0EBwaf1-sg_6jfXvlhZ5Nzpc"
  },
  integration: {
    // test.cardcash.com
    devMode: "integration",
    ga: "",
    anycardURL: "https://test-checkout.cardcash.com/test-checkout.js",
    siftScienceBeacon: "cebece9feb",
    x_cc_app: "GwVUL88BfHJ6",
    baseURL: "https://integration-api.cardcash.com/",
    baseServerURL: "http://api.integration/",
    siteHref: "https://test.cardcash.com",
    siteEnv: "https://test.cardcash.com",
    zipMerchantId: "6377dd80-099d-4d9c-a10c-0318c68a8669",
    zipTestEnv: true,
    zipJsURL: "https://cdn.sand.us.zip.co/v1/zip.js",
    zipMinOrderAmount: 35,
    zipMaxOrderAmount: 1500,
    bulkContactFormURL:
      "https://qmb19y9cy5.execute-api.us-east-1.amazonaws.com/dev/bulk-buy-gift-cards",
    aiAssistURL:
      "https://integration-ai-api.cardcash.com/v1/contact-form/assist",
    recaptchaV3SiteKey: "6LeyGwUuAAAAAO1K5D6VkXScTb6O8yjz2n02ObpL"
  },
  development: {
    devMode: "development",
    ga: "",
    x_cc_app: "GwVUL88BfHJ6",
    // anycardURL: 'http://localhost:9000/dist/widget.js',
    anycardURL: "https://test-checkout.cardcash.com/test-checkout.js",
    siftScienceBeacon: "cebece9feb",
    baseServerURL: "https://integration-api.cardcash.com/",
    // baseServerURL: "http://local.cardcash.com:8080/",
    baseURL: "https://integration-api.cardcash.com/",
    // baseURL: "https://local.cardcash.com:8443/",
    whenHosts: ["local.cardcash.com"],
    siteHref: "https://test.cardcash.com",
    siteEnv: "https://local.cardcash.com:3000",
    zipMerchantId: "6377dd80-099d-4d9c-a10c-0318c68a8669",
    zipTestEnv: true,
    zipJsURL: "https://cdn.sand.us.zip.co/v1/zip.js",
    zipMinOrderAmount: 35,
    zipMaxOrderAmount: 1500,
    bulkContactFormURL:
      "https://qmb19y9cy5.execute-api.us-east-1.amazonaws.com/dev/bulk-buy-gift-cards",
    aiAssistURL:
      "https://integration-ai-api.cardcash.com/v1/contact-form/assist",
    // aiAssistURL: "http://local.cardcash.com:3005/dev/contact-form/assist",
    recaptchaV3SiteKey: "6LeyGwUuAAAAAO1K5D6VkXScTb6O8yjz2n02ObpL"
  }
};

export const getConfiguration = options =>
  configBuilder("cardCash", layers, options);
